module.exports = __webpack_public_path__ + "static/media/aidinmatemothers.1d7adb24.jpg";